import { computeNodeId, computeEdgeId } from "./utils";

export function validateNode(node) {
  if (!node) throw new Error('invalid node: ' + node);
  if (!node.type) throw new Error('invalid node type: ' + node.type);
  if (node.value == null) throw new Error('invalid node value: ' + node.value); // throw for null AND undefined, but not empty string
}

export function validateEdge(edge) {
  if (!edge || !edge.from_type || edge.from_value == null || !edge.to_type || edge.to_value == null)
    throw new Error('invalid edge: missing required fields (from_type, from_value, to_type, to_value)');
}

export function nodeToVisId(node) {
  return computeNodeId(node.type, node.value);
}
export function edgeToVisIds(edge) {
  const from = computeNodeId(edge.from_type, edge.from_value);
  const to = computeNodeId(edge.to_type, edge.to_value);
  return {from, to, id: computeEdgeId(from, to)};
}



// TODO benchmark to see if there is a small optimization if we pass a precomputed id for nodes and edges

export function nodeToVisNode(node) {
  const visNode = {
    id: computeNodeId(node.type, node.value),
    label: node.label ? node.label : (node.value.length > 30 ? node.value.slice(0, 7) + '...' : node.value),
    group: node.type,
    title: node.value
  };
  if (node.visjsProps) {
    for (let visjsProp in node.visjsProps) {
      if (visjsProp === "id" || visjsProp === 'x' || visjsProp === 'y') continue;
      if (visjsProp === 'label' && !node.visjsProps[visjsProp]) continue;
      visNode[visjsProp] = node.visjsProps[visjsProp];
    }
  }
  return visNode;
}



export function edgeToVisEdge(edge) {
  const visEdge = {
    from: computeNodeId(edge.from_type, edge.from_value),
    to: computeNodeId(edge.to_type, edge.to_value),
  }
  visEdge.id = computeEdgeId(visEdge.from, visEdge.to);
  if (edge.visjsProps) {
    for (let visjsProp in edge.visjsProps) {
      if (visjsProp === "id" || visjsProp === "from" || visjsProp === "to") continue;
      visEdge[visjsProp] = edge.visjsProps[visjsProp];
    }
  }
  return visEdge;
}
